module.exports = __webpack_public_path__ + "img/login.aa3ff99b.jpg";